import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAnNIxFfGCSR8f22k6AMdw78l4lStgXhHQ",
  authDomain: "metua-54033.firebaseapp.com",
  databaseURL: "https://metua-54033-default-rtdb.firebaseio.com",
  projectId: "metua-54033",
  storageBucket: "metua-54033.appspot.com",
  messagingSenderId: "457371697298",
  appId: "1:457371697298:web:86bb321504d5a2d61f664b",
  measurementId: "G-Y7L97Q1DY8",
};

const app = initializeApp(firebaseConfig);

const messaging = getMessaging(app);
const db = getFirestore(app);

export { messaging, getToken, onMessage, db };
